import React, { Component, Fragment } from 'react';
import Helmet from 'react-helmet';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import LineMenu from '../../components/liveMenu/';
import LineList from '../../components/line/';
import Basket from '../../components/basket/';
import Settings from '../../components/settingsLine/';
import Top from '../../components/scrollTopButton/';
import Schedule from '../../components/schedule/';
import LoadingSpinner from '../../components/loadingSpinner/';
import SearchBox from '../../components/searchBox/';
import MovingStatistics from '../../components/movingStatistics/'; 
import IgWrapper from '~/components/ig';

@withRouter
@inject('accountStore', 'lineStore', 'igStore')
@observer
export default class Line extends Component {

  componentDidMount () {
    this.props.lineStore.init('live');
    this.props.lineStore.init2();
  }

  componentDidUpdate () {
    this.props.lineStore.route.setUrl(this.props.match.params);
    // console.log(this.props.match);
  }

  componentWillUnmount () {
    this.props.lineStore.clearnterval();
    this.props.igStore.close();
  }

  render () {
    const {basketPosition} = this.props.accountStore.accountSettings;
    const {isLoading, shortMenu, scheduleActive, basket: {toogleBasket}} = this.props.lineStore;
    const {game} = this.props.igStore;

    let showIg = {
      left: false,
      right: false
    };
    if (game) {
      if (toogleBasket.showArrow && basketPosition == 'right') {
        showIg.right = false;
        showIg.left = true;
      } else {
        showIg.right = true;
        showIg.left = false;
      }

      if (basketPosition == 'left') {
        showIg.right = false;
        showIg.left = true;
      }
    }

    return (
      <div className="live live-view">
        <Helmet>
          <title>ИРМ - Лайв</title>
        </Helmet>
        { isLoading ?
          <div>
            <LoadingSpinner/>
          </div> :
          <Fragment>
            <Settings/>
            <SearchBox/>
            <div
              className={ `line-left-column ${ shortMenu && basketPosition === 'right' ? 'line-left-column-short' : '' }${ basketPosition === 'left' ? ' line-left-column_scroll' : '' }` }
              id="line-left-column">
              { basketPosition == 'left' || showIg.left ?
                <div className="line-left-column-basket-cont">
                  { showIg.left ? <IgWrapper/> : '' }
                  { showIg.right || basketPosition == 'left' ? <Basket position='left'/> : ''}
                </div>
                : '' }
							{(toogleBasket.showArrow || basketPosition == 'left') && !shortMenu && <MovingStatistics/>}
              <LineMenu/>
              <Top/>
            </div>
            {/*<div className={`line-central-column l-c-c-c-s ${ basketPosition == 'right' ? 'line-central-column-short-right' : ''} ${shortMenu && basketPosition == 'right' ? 'line-central-column-short-left' : ''}`} id="line-central-column" >*/ }
            { scheduleActive ? <Schedule/> : <LineList key=""/> }
            {/*<LineList key="" />*/ }
            {/*</div>*/ }
            { basketPosition === 'right' || showIg.right ?
              <div className={ `line-right-column line-right-column-border${ toogleBasket.showBasket ? ' open' : '' }` }>
                { showIg.right ? <IgWrapper/> : '' }
                <Basket position='right'/>
								{!toogleBasket.showArrow && <MovingStatistics/>}
              </div>
              : '' }
          </Fragment>
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/routes/live/index.js